import store from "../store/index";
//-------------------
// get race by index
//-------------------
export default function getRaceByIndex(deletion_index) {
  var race = null;
  //--------------
  // access store
  //--------------
  const this_store = store.state.races;
  //-------------------------------------
  // get race deletion slug (for return)
  //-------------------------------------
  race = this_store.races[deletion_index];
  //---------
  // returns
  //---------
  return race;
}
